import React from "react";
import { Modal, Box, Button, Typography } from "@mui/material";

const UploadModal = ({
  open,
  setOpen,
  handleSubmit,
  handleFileChange,
  date,
  setDate,
  docId,
  setDocId,
  value,
}) => {
  // Function to open the modal
  const handleOpen = () => setOpen(true);

  // Function to close the modal
  const handleClose = () => {
    setOpen(false);
    setDate("");
    setDocId("");
  };

  return (
    <div>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-title"
        aria-describedby="modal-description"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 4,
            width: 400,
            borderRadius: 2,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 2,
          }}
        >
          <Typography
            id="modal-title"
            variant="h6"
            component="h2"
            sx={{
              fontSize: "24px",
              marginBottom: "15px",
              marginTop: "10px",
              textAlign: "center",
            }}
          >
            Upload{" "}
            {value === 0
              ? "Amendment"
              : value === 1
              ? "SOF"
              : value === 2
              ? "Invoices"
              : value === 3
              ? "Credit Note"
              : "Documents"}
          </Typography>

          {/* File input */}
          <input
            type="file"
            accept="application/pdf"
            onChange={handleFileChange}
            style={{
              marginBottom: "20px",
              fontSize: "18px",
              width: "100%",
              padding: "10px",
              borderRadius: "4px",
            }}
          />

          {/* <select
            id="service-dropdown"
            value={selectedVendor}
            onChange={(e) => {
              setSelectedVendor(e.target.value);
            }}
            style={{
              marginBottom: "20px",
              fontSize: "18px",
              width: "105%",
              padding: "15px",
              borderRadius: "4px",
            }}
          >
            <option value={-1} disabled>Please select vendor</option>
            {vendor.map((el) => (
              <option value={el.id}>{el.name}</option>
            ))}
          </select> */}

          {/* Date input */}
          <input
            type="date"
            value={date}
            onChange={(e) => setDate(e.target.value)}
            style={{
              marginBottom: "20px",
              fontSize: "18px",
              width: "100%",
              padding: "10px",
            }}
          />

          {/* Document ID input */}
          <input
            type="text"
            placeholder="Document ID"
            value={docId}
            onChange={(e) => setDocId(e.target.value)}
            style={{
              marginBottom: "30px",
              fontSize: "18px",
              width: "100%",
              padding: "10px",
            }}
          />

          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              width: "100%",
            }}
          >
            <Button
              onClick={() => handleSubmit()}
              style={{
                flex: 1,
                marginRight: "10px",
                fontSize: "18px",
                background: "#7C2EA0",
                color: "white",
                padding: "12px",
              }}
            >
              Submit
            </Button>
            <Button
              onClick={handleClose}
              style={{
                flex: 1,
                fontSize: "18px",
                background: "#7C2EA0",
                color: "white",
                padding: "12px",
              }}
            >
              Cancel
            </Button>
          </div>
        </Box>
      </Modal>
    </div>
  );
};

export default UploadModal;
